var React = require('react');

function SparksInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 3.5L19.6064 4.39362L20.5 7L21.3936 4.39363L24 3.5L21.3936 2.60641L20.5 0L19.6064 2.60642L17 3.5ZM13 8.5L14.6892 9.31085L15.5 11L16.3108 9.31085L18 8.5L16.3109 7.68928L15.5 6L14.6891 7.68927L13 8.5ZM15 1H5V21H23V9H21V19H7V3H15V1ZM2 4H4V22H20V24H2V4Z","fill":"#C7D5D9"}));
}

SparksInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":""};

module.exports = SparksInline;

SparksInline.default = SparksInline;
